<script lang="ts">
    import clickSound from '@root/src/utils/useClickSound';
    import { COMMON_BUTTON_VARIANTS } from '../../constants';

    let className = '';
    let baseClasses =
        'btn-base font-Roboto inline-flex items-center justify-center rounded-full px-8 py-2 tablet:py-2.5 text-center text-md font-bold uppercase hover:cursor-pointer desktop:text-xl desktop:px-10';

    let commonPrimaryBtn = 'common-primary-btn bg-cross-bgrd-blue hover:text-white relative items-center';
    let commonSecondaryBtn =
        'common-secondary-btn text-white border-white/30 hover:border-white hover:bg-white/10 active:text-black active:bg-white';

    export let variants; // primary || secondary
    export let disabled = false;
    export { className as class };
</script>

<button
    type="button"
    {disabled}
    class="{baseClasses} {variants === COMMON_BUTTON_VARIANTS.PRIMARY
        ? commonPrimaryBtn
        : commonSecondaryBtn} {className}"
    on:click
    use:clickSound={{ sound: 'audio_basic_click' }}
    ><slot />
</button>

<style>
    .common-primary-btn {
        border-radius: 40px;

        box-shadow: 0 6px 6px 0 rgba(0, 10, 26, 0.5);
        color: #fff;
    }

    .common-primary-btn:hover {
        background: linear-gradient(0deg, #3d89ff, #3d89ff),
            linear-gradient(135deg, rgba(255, 255, 255, 0.32) 0%, rgba(0, 0, 0, 0) 100%);
    }

    .common-primary-btn:active {
        background: linear-gradient(0deg, #195fcc, #195fcc),
            linear-gradient(135deg, rgba(255, 255, 255, 0.32) 0%, rgba(0, 0, 0, 0) 100%);
        box-shadow: 0 4px 4px 0 #030c1a80 inset;
        color: theme(colors[cross-n[100]]);
    }
    .common-secondary-btn {
        border-radius: 40px;
        box-shadow: 0 6px 6px 0 rgba(0, 10, 26, 0.5);
    }
</style>
